module.exports = __webpack_public_path__ + "img/expert-1.0480be79.png";